export default {
    name: {
      presence: { allowEmpty: false, message: 'is required' },
      length: {
        maximum: 16
      }
    },
    email: {
      presence: { allowEmpty: false, message: 'is required' },
      email: true,
      length: {
        maximum: 64
      }
    },
    password: {
      presence: { allowEmpty: false, message: 'is required' },
      length: {
        maximum: 128
      }
    }
  };
  